module.exports = __webpack_public_path__ + "img/arrow-left-white.254f03f6.svg";